<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Histórico de Consultas</h3>
                <p class="text-muted">Asi se comportan tus consultas en el tiempo.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="line" :options="chartOptions" :series="chartSeries" height="350" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "ConsultasHistorico",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            chartOptions: {
                chart: {
                    type: "line",
                    zoom: {
                        enabled: true
                    }
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        formatter: function (value) {
                            const date = new Date(value);
                            return date.toLocaleDateString("es-MX", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric"
                            });
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "Total Consultas"
                    }
                },
                colors: ["#9353e5"],
                stroke: {
                    curve: "smooth"
                },
                tooltip: {
                    x: {
                        formatter: function (value) {
                            const date = new Date(value);
                            return date.toLocaleDateString("es-MX", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            });
                        }
                    }
                }
            },
            chartSeries: []
        };
    },
    mounted() {
        this.fetchConsultasHistorico();
    },
    methods: {
        async fetchConsultasHistorico() {
            try {
                const response = await axios.get(`${API}/consultas_por_fecha`, {
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    const data = response.data.data;
                    this.chartSeries = [
                        {
                            name: "Consultas",
                            data: data.map(item => ({
                                x: item.fecha,
                                y: item.total_consultas
                            }))
                        }
                    ];
                } else {
                    this.notify("error", "No se pudo obtener el histórico de consultas.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #9353e5, #59bfff);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
